"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormMultiChooseInput = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
const Price_1 = require("../../../../../public/js/utils/Price");
var ControlsFormMultiChooseInput;
(function (ControlsFormMultiChooseInput) {
    class Config {
        static inputContainerClass = "MultiChooseInput";
        static inputSelectClass = "MultiChooseInput-select";
        static inputOptionItemClass = "MultiChooseInput-choose-option";
        static optionPriceDataName = "price";
        static optionExtraPriceDataName = "extraPrice";
        static optionExtraPriceCurrentDataName = "extraPriceCurrent";
        static skipPriceInitDataName = "skipPriceInit";
        static optionPriceTargetElementClass = "MultiChooseInput-choose-option-right-price";
        static optionIdentifyIdDataName = "identify";
        static changeModeDataName = "changeMode";
        static multiDataName = "multi";
        static enabledDataName = "enabled";
        static currentDataName = "current";
        static disabledDataName = "disabled";
        static alwaysEnabledDataName = "always";
    }
    ControlsFormMultiChooseInput.Config = Config;
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static initializeElement(element) {
            DOM_1.DOM.Parser.getParentElement(element).classList.replace('m6', 'm12');
            DOM_1.DOM.Parser.getParentElement(element).classList.replace('l4', 'l12');
            this.initializePrices(element);
            this.triggerOptionToggles(element);
            this.syncWithSelectInput(element);
        }
        static initializePrices(element, multiplyExtraPrice) {
            const skipPriceInit = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.skipPriceInitDataName, element) === "yes";
            if (skipPriceInit) {
                return;
            }
            this.updatePrices(element, multiplyExtraPrice);
        }
        static updatePrices(element, multiplyExtraPrice) {
            const changeMode = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.changeModeDataName, element) === "yes";
            const options = DOM_1.DOM.Parser.getHtmlElements(Config.inputOptionItemClass, element, true);
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                const priceData = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionPriceDataName, option);
                const extraPriceData = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionExtraPriceDataName, option);
                const extraPriceCurrentData = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionExtraPriceCurrentDataName, option);
                const price = priceData === null ? null : JSON.parse(priceData);
                const extraPrice = extraPriceData === null ? null : JSON.parse(extraPriceData);
                const extraPriceCurrent = extraPriceCurrentData === null ? null : JSON.parse(extraPriceCurrentData);
                if (price === null && extraPrice === null) {
                    continue;
                }
                const totalPrice = {
                    price: ((price?.price ?? 0) + ((extraPrice?.price ?? 0) * (multiplyExtraPrice ? multiplyExtraPrice : 1))) - (extraPriceCurrent ? extraPriceCurrent.price : 0),
                    currency: price ? price.currency : extraPrice.currency
                };
                if (extraPrice) {
                    extraPrice.multiply = multiplyExtraPrice;
                    option.dataset[Config.optionExtraPriceDataName] = JSON.stringify(extraPrice);
                }
                const targetPriceElement = DOM_1.DOM.Parser.getHtmlElementByClass(Config.optionPriceTargetElementClass, option);
                targetPriceElement.innerText = (new Price_1.Price.Initializer()).getPriceAmountStringFromPriceObject(totalPrice, false, changeMode);
            }
        }
        static triggerOptionToggles(element) {
            const isMulti = DOM_1.DOM.Parser.getDataByNameFromElement(Config.multiDataName, element) === 'yes';
            const triggers = DOM_1.DOM.Parser.getHtmlElements(Config.inputOptionItemClass, element, true);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                trigger.addEventListener('click', () => {
                    const optionDisabled = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.disabledDataName, trigger) === "yes";
                    const optionAlwaysEnabled = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.alwaysEnabledDataName, trigger) === "yes";
                    if (optionDisabled || optionAlwaysEnabled) {
                        return;
                    }
                    trigger.dataset.enabled = trigger.dataset.enabled === 'yes' ? 'no' : 'yes';
                    const clickedIdentify = DOM_1.DOM.Parser.getDataByNameFromElement(Config.optionIdentifyIdDataName, trigger);
                    if (!isMulti) {
                        for (let j = 0; j < triggers.length; j++) {
                            const boxOption = triggers[j];
                            const boxOptionIdentify = DOM_1.DOM.Parser.getDataByNameFromElement(Config.optionIdentifyIdDataName, boxOption);
                            if (boxOptionIdentify !== clickedIdentify) {
                                boxOption.dataset.enabled = 'no';
                            }
                        }
                    }
                    this.syncWithSelectInput(element);
                });
            }
        }
        static syncWithSelectInput(element) {
            const enabledIds = [];
            const optionBoxes = DOM_1.DOM.Parser.getHtmlElements(Config.inputOptionItemClass, element, true);
            for (let i = 0; i < optionBoxes.length; i++) {
                const optionBox = optionBoxes[i];
                const enabled = DOM_1.DOM.Parser.getDataByNameFromElement(Config.enabledDataName, optionBox) === 'yes';
                if (!enabled) {
                    continue;
                }
                const identify = DOM_1.DOM.Parser.getDataByNameFromElement(Config.optionIdentifyIdDataName, optionBox);
                enabledIds.push(identify);
            }
            const selectInput = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputSelectClass, element);
            const options = DOM_1.DOM.Parser.getHtmlElementsByQuery('option', selectInput);
            for (let j = 0; j < options.length; j++) {
                const option = options[j];
                if (enabledIds.includes(option.value)) {
                    option.setAttribute('selected', 'selected');
                }
                else {
                    option.removeAttribute('selected');
                }
            }
            selectInput.dispatchEvent(new Event("change"));
        }
        static getMultiChoosePriceList(multiChoose, changeMode) {
            const options = DOM_1.DOM.Parser.getHtmlElements(Config.inputOptionItemClass, multiChoose);
            const prices = [];
            for (let j = 0; j < options.length; j++) {
                const option = options[j];
                const enabled = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.enabledDataName, option) === "yes";
                const current = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.currentDataName, option) === "yes";
                const price = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionPriceDataName, option);
                const extraPrice = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionExtraPriceDataName, option);
                let priceDecoded = price ? JSON.parse(price) : null;
                let extraPriceDecoded = extraPrice ? JSON.parse(extraPrice) : null;
                if (changeMode) {
                    if (priceDecoded && ((!current || !enabled) && (current || enabled))) {
                        priceDecoded.price = (current && !enabled) ? -priceDecoded.price : priceDecoded.price;
                        prices.push(priceDecoded);
                    }
                    if (extraPriceDecoded) {
                        const extraPriceCurrent = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.optionExtraPriceCurrentDataName, option);
                        let extraPriceCurrentDecoded = extraPriceCurrent ? JSON.parse(extraPriceCurrent) : null;
                        const price = (extraPriceDecoded.price * (extraPriceDecoded.multiply ? extraPriceDecoded.multiply : 1))
                            - (extraPriceCurrentDecoded?.price ? extraPriceCurrentDecoded.price : 0);
                        prices.push({ price: price, currency: extraPriceDecoded.currency });
                    }
                }
                else {
                    if (!enabled) {
                        continue;
                    }
                    if (priceDecoded) {
                        prices.push(priceDecoded);
                    }
                    if (extraPriceDecoded) {
                        prices.push(extraPriceDecoded);
                    }
                }
            }
            return prices;
        }
    }
    ControlsFormMultiChooseInput.Control = Control;
})(ControlsFormMultiChooseInput || (exports.ControlsFormMultiChooseInput = ControlsFormMultiChooseInput = {}));
